import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-skeleton',
    templateUrl: './loading-skeleton.component.html',
    styleUrls: ['./loading-skeleton.component.scss'],
    standalone: false
})
export class LoadingSkeletonComponent implements OnInit {

  @Input() absence;

  constructor() { }

  ngOnInit() {}

}
